import(/* webpackMode: "eager" */ "/tebuto/node_modules/.pnpm/next@16.3.4_@babel+core@7.29.7_supports-color@5.5.0__@opentelemetry+api@1.9.1_@playwrig_38461adb8ffa252a027214c386adec9a/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ReadingProgressBar"] */ "/tebuto/webapp/src/components/content/ReadingProgressBar.tsx");
